import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import hamburger from "../assets/svg/hamburger.svg";
import logo from "../assets/images/logo.png";
import { MdLogout } from "react-icons/md";
import Logout from "../Components/Logout";
import "react-toastify/dist/ReactToastify.css";
import ProfileImage from "../assets/images/profile-img.jpg";

const Header = ({ toggleSidePanel }) => {
  const [isLogoutOpen, setIsLogoutOpen] = useState(false);
  const [isProfileSubMenuOpen, setIsProfileSubMenuOpen] = useState(false);
  const location = useLocation();
  const user = location.state?.user || {};

  const toggleProfileMenu = () => {
    setIsProfileSubMenuOpen((prev) => !prev);
  };

  return (
    <header className="flex w-full overflow-hidden header-container">
      {/* Main Content */}
      <div className="flex-1">
        <div className="flex border-b border-[#545454] shadow-md">
          {/* Logo */}
          <div className="text-center w-[19.5rem] py-4">
            <Link to="/dashboard">
              <img src={logo} alt="PG Logo" className="h-12 mx-auto" />
            </Link>
          </div>

          {/* Navbar */}
          <div className="flex justify-between items-center bg-[#282828] p-4 w-full">
            {/* Hamburger Menu */}
            <div
              onClick={toggleSidePanel} // Toggle SidePanel when clicked
              className="w-12 h-12 flex items-center justify-center bg-[#3E3E42] rounded cursor-pointer"
            >
              <img src={hamburger} alt="menu" />
            </div>

            {/* Profile Section */}
            <div className="flex items-center gap-4">
              <button
                onClick={toggleProfileMenu}
                className="flex items-center gap-2 bg-[#3E3E42] px-4 py-2 rounded hover:bg-[#4e4e4e] transition relative"
              >
                <span className="text-sm text-white">Admin</span>
                <img
                  src={ProfileImage}
                  alt="Profile"
                  className="w-8 h-8 rounded-full object-cover"
                />
              </button>

              {isProfileSubMenuOpen && (
                <ul className="absolute right-0 top-[60px] w-36 bg-[#2c2c2c] rounded shadow-lg border border-[#545454] animate-fade-in text-sm text-white">
                  <li>
                    <button
                      className="w-full text-left flex items-center gap-3 p-3 hover:bg-[#3b3b3b] transition"
                      onClick={() => setIsLogoutOpen(true)}
                    >
                      <MdLogout size={20} className="text-red-500" />
                      Sign Out
                    </button>
                  </li>
                </ul>
              )}
            </div>
          </div>
        </div>
      </div>
      <Logout isOpen={isLogoutOpen} onClose={() => setIsLogoutOpen(false)} />
    </header>
  );
};

export default Header;
